import { gql } from '@apollo/client'

export const SmsTemplateDetailsFragment = gql`
  fragment SmsTemplateDetails on SmsTemplate {
    id
    type
    message
    tokens
  }
`
